import * as React from "react";
import Image from "next/image";
import BFMVector from "@public/bfm.svg";
import { WhyUseLumiPageQuery } from "@graphql/generated/graphql";
import { Trans } from "@lingui/macro";

interface IPublisherListProps {
  data: WhyUseLumiPageQuery;
}

type NewsPublisherProps = {
  id: string;
  name: string;
  slug: string;
  vectorUrl?: string;
  imageUrl: string;
};

const PublisherList: React.FunctionComponent<IPublisherListProps> = ({
  data: { languages },
}) => {
  const allPublishers: NewsPublisherProps[] = [];

  languages.map(({ newsPublishers }) =>
    newsPublishers.map((publisher) => allPublishers.push(publisher))
  );

  const publishersWithVector = allPublishers.filter(
    ({ vectorUrl }) => vectorUrl
  );
  const featuredPublishers = [
    {
      id: 1,
      name: "Buletin TV3",
      link: "https://www.youtube.com/watch?v=dOQef3aLIJk",
      vectorUrl: "",
    },
    {
      id: 2,
      name: "八度空间华语新闻",
      link: "https://youtu.be/ViSGBse1xjE",
      vectorUrl: "",
    },
    {
      id: 3,
      name: "New Straits Times",
      link: "https://www.nst.com.my/lifestyle/bots/2022/04/789765/lumi-news-app-combines-malaysias-top-stories-one-personalised-feed",
      vectorUrl: "",
    },
    {
      id: 4,
      name: "FMT News",
      link: "https://www.freemalaysiatoday.com/category/leisure/2022/04/29/local-news-app-curates-must-read-articles-in-one-shareable-feed",
      vectorUrl: "",
    },
    {
      id: 5,
      name: "Berita Harian",
      link: "https://www.bharian.com.my/berita/nasional/2022/04/947735/lebih-mudah-kongsi-berita-terkini-dengan-lumi-news-malaysia",
      vectorUrl: "",
    },
    {
      id: 6,
      name: "Harian Metro",
      link: "https://www.hmetro.com.my/mutakhir/2022/04/834032/ciri-baharu-lumi-news-memudahkan-orang-ramai-dapatkan-berita-terkini",
      vectorUrl: "",
    },
    {
      id: 7,
      name: "SAYS",
      link: "https://says.com/my/lifestyle/malaysia-bags-gold-feel-good-stories-may",
      vectorUrl: "",
    },
    {
      id: 8,
      name: "Mashable Southeast Asia",
      link: "https://sea.mashable.com/tech/20145/elon-musk-buys-twitter-and-other-important-tech-news-populated-in-one-news-app",
      vectorUrl: "",
    },
    {
      id: 9,
      name: "OHBULAN!",
      link: "https://ohbulan.com/lumi-news-senaraikan-tempat-berbuka-menarik-ramadan-dari-bazar-ke-bufet-hotel-semua-ada",
      vectorUrl: "",
    },
    {
      id: 10,
      name: "Rojak Daily",
      link: "https://gempak.com/rojakdaily/news/we-are-lumi-news-malaysianmade-app-curates-local-news-72943",
      vectorUrl: "",
    },
    {
      id: 11,
      name: "ViralCham",
      link: "https://viralcham.com/app-android/lumi-app-up-ac-210422/",
      vectorUrl: "",
    },
    {
      id: 12,
      name: "Rojaklah",
      link: "https://rojaklah.com/?p=487150&preview=1&_ppp=face2b8939",
      vectorUrl: "",
    },
    {
      id: 13,
      name: "SAYS SEISMIK",
      link: "https://says.com/shorten/3gp",
      vectorUrl: "",
    },
    {
      id: 14,
      name: "JUICE",
      link: "https://juiceonline.com/lumi-local-app-that-news-publishers-topics/",
      vectorUrl: "",
    },
    {
      id: 15,
      name: "SirapLimau",
      link: "https://siraplimau.com/pupuk-minat-membaca-sejak-dari-kecil-dengan-aplikasi-berita-ini-ibu-bapa-tak-risau-lagi/",
      vectorUrl: "",
    },
    {
      id: 16,
      name: "BFM",
      link: "https://www.bfm.my/podcast/evening-edition/Evening%20Edition/greeting-your-mornings-with-good-news",
      vectorUrl: BFMVector,
    },
  ];

  const map = new Map(publishersWithVector.map((o) => [o.name, o]));

  featuredPublishers.forEach(
    (publisher) =>
      map.has(publisher.name) &&
      (publisher.vectorUrl = map.get(publisher.name).vectorUrl)
  );

  return (
    <div className="-mx-6 mb-16 -mt-20 bg-white px-6 md:mb-40">
      <div className="flex justify-center">
        <Trans>
          <p className="mb-16 max-w-sm text-center font-poppins text-[31px] font-bold md:mb-20 md:text-[39px]">
            As featured on
          </p>
        </Trans>
      </div>

      <div className="-mx-8 flex max-w-7xl flex-wrap justify-center md:mx-auto">
        {featuredPublishers.map(({ vectorUrl, link, name, id }) => (
          <a href={link} target="blank" key={id}>
            <div className="publisher-img-div relative my-4 mx-4 h-6 cursor-pointer md:h-8">
              <Image
                src={vectorUrl}
                alt={name}
                layout="fill"
                objectFit="contain"
                className="publisher-img"
                priority
              />
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default PublisherList;
